/** @format */

import styled from 'styled-components';

export const DotsContainer = styled.div`
  display: flex;
  gap: 4px;
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;

export const Dot = styled.div<{ active: boolean }>`
  width: 6px;
  height: 6px;
  background-color: ${({ active }) => (active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.5)')};
  border-radius: 50%;
  transition: background-color 0.2s ease;
`;
